import { Box, Grid } from '@mui/material';
import React from 'react';
import Title from '../common/Title';
import PricingCard from './PricingCard';
import { ReactComponent as PricingLight } from '../../assets/pricing_light.svg';
import { ReactComponent as PricingFull } from '../../assets/pricing_full.svg';
import { PricingModelType } from '../Home';

const Pricing = ({
  openContact,
  pricingRef,
}: {
  openContact: (pricingModel?: PricingModelType) => void;
  pricingRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5.65rem 2rem',
        width: '100%',
      }}
      id="pricing"
      ref={pricingRef}
    >
      <Title
        title="pricing.title"
        dark
        topTitle="pricing.topTitle"
        red
        big
        sx={{
          marginBottom: '4rem',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          gap: '1rem',
          width: '100%',
          maxWidth: '1250px !important',
          overflowX: 'scroll',
          scrollSnapType: 'x mandatory',
        }}
      >
        <PricingCard
          title="pricing.light.title"
          price="pricing.light.price"
          onClick={() => openContact('light')}
          features={[
            {
              title: 'pricing.light.features.1.title',
              description: 'pricing.light.features.1.description',
            },
            {
              title: 'pricing.light.features.2.title',
            },
            {
              title: 'pricing.light.features.3.title',
              description: 'pricing.light.features.3.description',
            },
            {
              title: 'pricing.light.features.4.title',
            },
            {
              title: 'pricing.light.features.5.title',
            },
          ]}
          button="pricing.light.price"
          Icon={PricingLight}
          lastInfo="pricing.light.lastInfo"
        />
        <PricingCard
          title="pricing.full.title"
          price="pricing.full.price"
          onClick={() => openContact('full')}
          features={[
            {
              title: 'pricing.full.features.1.title',
            },
            {
              title: 'pricing.full.features.2.title',
            },
            {
              title: 'pricing.full.features.3.title',
              description: 'pricing.full.features.3.description',
            },
            {
              title: 'pricing.full.features.4.title',
            },
          ]}
          button="pricing.full.price"
          Icon={PricingFull}
        />
        <PricingCard
          title="pricing.meaningful.title"
          price="pricing.meaningful.price"
          description="pricing.meaningful.description"
          onClick={() => openContact('meaningful')}
          features={[
            {
              title: 'pricing.meaningful.features.1.title',
            },
            {
              title: 'pricing.meaningful.features.2.title',
            },
          ]}
          button="pricing.meaningful.price"
          Icon={PricingFull}
          lastInfo="pricing.meaningful.lastInfo"
        />
        <PricingCard
          title="pricing.cmbc.title"
          price="pricing.cmbc.price"
          description="pricing.cmbc.description"
          onClick={() => openContact('cmbc')}
          features={[
            {
              title: 'pricing.cmbc.features.1.title',
            },
            {
              title: 'pricing.cmbc.features.2.title',
            },
          ]}
          button="pricing.cmbc.price"
          Icon={PricingFull}
          lastInfo="pricing.cmbc.lastInfo"
        />
      </Box>
    </Grid>
  );
};

export default Pricing;

